export default {
    'export': 'Exportar',
    'export-as-excel': 'Exportar a excel',
    'print-journal-table': 'Imprimir diario',
    'search-within-caption': 'Buscar por descripción',
    'from-date': 'De fecha',
    'to-date': 'Hasta fecha',
    'only-debit-entries': 'Solo asientos de débito',
    search: 'Buscar',
    cancel: 'Cancelar',

    'sum-result-headers': {
        'sum-debits': 'Total de débito',
        'sum-credits': 'Total de crédito',
        difference: 'Deferencia',
        'equivalent-currency': 'Moneda equivalente',
        'currency-equivalent': 'Saldo en otra moneda',
    },
    
    'sum-currencies-result-headers': {
        'currency-debits': 'Débito total de monedas',
        'currency-credits': 'Crédito total de monedas',
        'difference': 'Deferencia'
    },
    
    headers: {
        'bond-no': 'Número de bono',
        sequence: 'Serial',
        account: 'Cuenta',
        'account-no': 'Número de cuenta',
        debit: 'Débito',
        credit: 'Crédito',
        note: 'Descripción',
        currency: 'Moneda',
        'currency-debit': 'Moneda de débito',
        'currency-credit': 'Moneda de crédito',
        price: 'Precio',
        'paper-document-no': 'Ref. doc.',
        date: 'Fecha',
    },
    
    'details-depending-on-currencies' : 'Total detallado por monedas',
}